module.exports = __webpack_public_path__ + "static/media/teacher-comp-banner-x2.685fe656.jpg";